goog.provide("shadow.js.shim.module$jszip_utils");
goog.provide("module$shadow_js_shim_module$jszip_utils");
shadow.js.shim.module$jszip_utils = shadow.js.nativeProvides["jszip-utils"] = shadow$bridge("jszip-utils");
module$shadow_js_shim_module$jszip_utils.default = shadow.js.shim.module$jszip_utils;
